import { createMarkup } from '@allesauto/utils/funcs';
import {
  FieldTypeHTML,
  ITypeListMarker,
  ITypeListMarkerColor,
} from '@allesauto/utils/storyblok';
import { renderRichText } from '@storyblok/react';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React, { FC } from 'react';

export interface FullWidthComponent {
  title?: string;
  html?: FieldTypeHTML;
  listItemMarker?: ITypeListMarker;
  listItemMarkerColor?: ITypeListMarkerColor;
  component: string;
  _uid: string;
  _editable?: string;
}

/**
 * Variation of the text-component that renders across the full width
 * of the layout that contains styles for FieldTypeHTML richtext
 */
const TextComponentFullWidth: FC<FullWidthComponent> = (props) => {
  const { title, html, listItemMarker, listItemMarkerColor } = props;

  return (
    <div {...sbEditable(props)} className="sm:pt-40px md:pt-80px">
      <div className="grid grid-cols-24 sm:last:pb-0 sm:pb-40px md:pb-80px">
        <div className="col-end-24 relative sm:col-start-2 md:col-start-4">
          {title && (
            <h3 className="font-headline mb-40px text-grey100 text-headline3">
              {title}
            </h3>
          )}
          {html && (
            <div
              className={clsx(
                `rich-text rich-text-list-marker-${
                  listItemMarker ? listItemMarker : 'bullet'
                }-${listItemMarkerColor ? listItemMarkerColor : 'purple'}`
              )}
              {...(html && {
                dangerouslySetInnerHTML: createMarkup(
                  renderRichText(html as FieldTypeHTML)
                ),
              })}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TextComponentFullWidth;
